import { setupLayouts } from 'virtual:generated-layouts'
import { watch } from 'vue'
// eslint-disable-next-line import/no-duplicates
import { createRouter, createWebHistory } from 'vue-router'
// eslint-disable-next-line import/no-duplicates
import { routes } from 'vue-router/auto-routes'
import { useUserStore } from '../stores/user'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: setupLayouts(routes),
})

// 路由守卫
router.beforeEach(async (to, _from, next) => {
  const userStore = useUserStore()

  // 等待认证状态初始化完成，添加超时机制防止死锁
  if (!userStore.initialized || userStore.loading) {
    const authInitPromise = new Promise<void>((resolve) => {
      const unwatch = watch(
        [() => userStore.initialized, () => userStore.loading],
        ([initialized, loading]) => {
          if (initialized && !loading) {
            unwatch()
            resolve()
          }
        },
        { immediate: true },
      )
    })

    const timeoutPromise = new Promise<void>((_, reject) => {
      setTimeout(() => {
        reject(new Error('Authentication initialization timeout after 10 seconds'))
      }, 10000)
    })

    try {
      await Promise.race([authInitPromise, timeoutPromise])
    }
    catch (error) {
      console.error('Router guard timeout:', error)
      // 超时情况下，如果是公开路由就继续，否则重定向到登录页
      const publicRoutes = ['/login', '/signup', '/oauth-callback']
      if (publicRoutes.includes(to.path)) {
        next()
        return
      }
      else {
        next('/login')
        return
      }
    }
  }

  // 公开路由，不需要认证
  const publicRoutes = ['/login', '/signup', '/oauth-callback']
  const isPublicRoute = publicRoutes.includes(to.path)
  console.log('to.path', to.path)

  // 如果是公开路由
  if (isPublicRoute) {
    // 如果已经登录，重定向到首页
    if (userStore.isAuthenticated) {
      next('/')
      return
    }
    next()
    return
  }

  // 检查是否需要认证
  if (!userStore.isAuthenticated) {
    // 未登录，重定向到登录页
    console.log('User not authenticated, redirecting to login. Auth state:', {
      hasUserInfo: !!userStore.userInfo,
      hasAccessToken: !!userStore.accessToken,
      hasSupabaseToken: !!userStore.supabaseToken,
      loading: userStore.loading,
      initialized: userStore.initialized,
    })
    window.location.href = import.meta.env.VITE_APP_AUTH_URL_CONTENTS
    return
  }

  // 已登录，允许访问
  console.log('User authenticated, allowing access to:', to.path)
  next()
})
